

// import React, { useRef, useState, useEffect } from 'react';
// import styled, { keyframes } from 'styled-components';
// import { FaEnvelope, FaPhoneAlt, FaBars, FaWindowClose } from 'react-icons/fa';
// import { NavLink, useNavigate, useLocation } from 'react-router-dom';
// import logo from '../Images/logo.png';

// const floatingAnimation = keyframes`
//   0% { transform: translateY(0); }
//   50% { transform: translateY(-10px); }
//   100% { transform: translateY(0); }
// `;

// const sparkleAnimation = keyframes`
//   0% { opacity: 0.2; transform: scale(1); }
//   50% { opacity: 1; transform: scale(1.2); }
//   100% { opacity: 0.2; transform: scale(1); }
// `;

// const HeaderWrap = styled.div`
//   width: 100%;
//   display: ${({ hide }) => (hide ? 'none' : 'flex')};
//   flex-direction: column;
//   align-items: center;
//   background-color: white;

//   top: 0;
//   z-index: 9999;

//   box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
// `;

// const HeaderUp = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   width: 90%;
//   padding: 20px 0;
//   position: relative;
//   @media (max-width: 884px) {
//     flex-direction: column;
//     justify-content: center;
//     gap: 10px;
//   }
// `;

// const HeaderUpLeft = styled.h2`
//   color: #439E6D;
//   font-weight: bolder;
//   font-size: 1.5rem;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   flex-direction: column;
// `;

// const HeaderUpRight = styled.div`
//   display: flex;
//   gap: 20px;
//   color: #439E6D;
//   @media (max-width: 768px) {
//     flex-direction: column;
//     gap: 5px;
//     align-items: center;
//   }
//   p {
//     color: gray;
//   }
// `;

// const HeaderUpRightItem = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 5px;
//   text-align:center;
// `;

// const HeaderDown = styled.nav`
//   width: 100%;
//   display: ${({ mobile }) => (mobile ? 'none' : 'flex')};
//   justify-content: center;
//   gap: 20px;
//   align-items: center;
//   padding: 10px 0;
//   background-color: #439E6D;
//   @media (max-width: 884px) {
//     display: none;
//   }
// `;






// const slideDown = keyframes`
//   from {
//     transform: translateY(-200px);
//     opacity: 0;
//   }
//   to {
//     transform: translateY(0);
//     opacity: 1;
//   }
// `;

// const MobileMenuIcon = styled.div`
//   display: none;
//   cursor: pointer;
//   font-size: 1.5rem;

//   @media (max-width: 884px) {
//     display: block;
//     position: absolute;
//     top: 20px;
//     right: 20px;
    
//   }
// `;



// const MobileMenu = styled.div`
//   display: ${({ open }) => (open ? 'flex' : 'none')};
//   flex-direction: column;
//   background-color: #0092CF;
//   width: 100%;
//   padding: 20px;
//   z-index: 1000;

// `;

// const MenuItem = styled(NavLink)`
//   text-decoration: none;
//   color: white;
//   padding: 10px;
//   border-radius: 5px;
//   font-size:0.8rem;
//   transition: transform 0.3s ease-in-out;
//   &:hover {
//     transform: scale(1.1);
//   }
//   &.active {
//     background-color: rgba(255, 255, 255, 0.9);
//     color: #439E6D;
//   }
//   @media (min-width: 768px) {
//     font-size: 0.8rem;
//     padding: 5px;
//   }
// `;

// const Img = styled.img`
//   width: 70px;
//   height: auto;
//   position: relative;


//   @keyframes moveLogo {
//     0% { transform: translateX(-50px); }
//     50% { transform: translateX(50px); }
//   }
// `;

// const Sparkles = styled.div`
//   position: absolute;
//   top: 5px;
//   right: 5px;
//   width: 10px;
//   height: 10px;
//   background-color: yellow;
//   border-radius: 50%;

// `;

// const H2 = styled.h2`
//   font-size: 1.5rem;
// `;

// const Header = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const menuRef = useRef();

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setMobileMenuOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   const hideHeader = ['/userlogin', '/usersignup', '/forgotpassword'].some(path => location.pathname.includes(path));

//   return (
//     <HeaderWrap hide={hideHeader}>
//       <HeaderUp>
//         <HeaderUpLeft>
//           <Img src={logo} alt='logo'/>
//           {/* <H2>OCKENS </H2> */}
//         </HeaderUpLeft>
//         <HeaderUpRight>
//           <HeaderUpRightItem>
//             <FaEnvelope /><p>padecglobalservices@gmail.com</p>
//           </HeaderUpRightItem>
//           <HeaderUpRightItem>
//             <FaPhoneAlt /><p>+234(0)803 457 9614 ,+234(0)904 974 3886</p>
//           </HeaderUpRightItem>
//           {!mobileMenuOpen && <MobileMenuIcon onClick={() => setMobileMenuOpen(!mobileMenuOpen)}><FaBars /></MobileMenuIcon>}
//           {mobileMenuOpen && <MobileMenuIcon onClick={() => setMobileMenuOpen(!mobileMenuOpen)}><FaWindowClose /></MobileMenuIcon>}
//         </HeaderUpRight>
//       </HeaderUp>
//           <HeaderDown>
//         <Sparkles />
//         <MenuItem to='/'>HOME</MenuItem>
//         <MenuItem to='/aboutus'>ABOUT US</MenuItem>
//         <MenuItem to='/ourservices'>SERVICES</MenuItem>
//         <MenuItem to='/news'>NEWS</MenuItem>
//         <MenuItem to='/nigeriancontent'>NIGERIAN CONTENT</MenuItem>
//         <MenuItem to='/contactus'>CONTACT US</MenuItem>
//       </HeaderDown>

//       <MobileMenu ref={menuRef} open={mobileMenuOpen}>
//          <MenuItem to='/' onClick={() => setMobileMenuOpen(false)}>HOME</MenuItem>
//          <MenuItem to='/aboutus' onClick={() => setMobileMenuOpen(false)}>ABOUT US</MenuItem>
//          <MenuItem to='/ourservices' onClick={() => setMobileMenuOpen(false)}>SERVICES</MenuItem>
//          <MenuItem to='/news' onClick={() => setMobileMenuOpen(false)}>NEWS</MenuItem>
//          <MenuItem to='/nigeriancontent' onClick={() => setMobileMenuOpen(false)}>NIGERIAN CONTENT</MenuItem>
//          <MenuItem to='/contactus' onClick={() => setMobileMenuOpen(false)}>CONTACT US</MenuItem>
//        </MobileMenu>
//     </HeaderWrap>
//   );
// };

// export default Header;




import React, { useRef, useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { FaEnvelope, FaPhoneAlt, FaBars, FaWindowClose, FaChevronDown } from 'react-icons/fa';
import { NavLink, useLocation } from 'react-router-dom';
import logo from '../Images/logo.png';

const floatingAnimation = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0); }
`;

const sparkleAnimation = keyframes`
  0% { opacity: 0.2; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
  100% { opacity: 0.2; transform: scale(1); }
`;

const HeaderWrap = styled.div`
  width: 100%;
  display: ${({ hide }) => (hide ? 'none' : 'flex')};
  flex-direction: column;
  align-items: center;
  background-color: white;
  top: 0;
  z-index: 9999;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`;

const HeaderUp = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  padding: 2px 0;
  position: relative;

  @media (max-width: 884px) {
    flex-direction: column;
    justify-content: center;
    gap: 10px;
  }
`;

const HeaderUpLeft = styled.h2`
  color: #439E6D;
  font-weight: bolder;
  font-size: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const HeaderUpRight = styled.div`
  display: flex;
  gap: 20px;
  color: #439E6D;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 5px;
    align-items: center;
  }

  p {
    color: gray;
    font-size:1.1rem;
  }
`;

const HeaderUpRightItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  text-align: center;
`;

const HeaderDown = styled.nav`
  width: 100%;
  display: ${({ mobile }) => (mobile ? 'none' : 'flex')};
  justify-content: center;
  gap: 20px;
  align-items: center;
  // padding: 2px 0;
  background-color: #439E6D;

  @media (max-width: 884px) {
    display: none;
  }
`;

const MobileMenuIcon = styled.div`
  display: none;
  cursor: pointer;
  font-size: 1.5rem;

  @media (max-width: 884px) {
    display: block;
    position: absolute;
    top: 20px;
    right: 20px;
  }
`;

const MobileMenu = styled.div`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  flex-direction: column;
  background-color: #0092CF;
  width: 100%;
  padding: 20px;
  z-index: 1000;
`;

const MenuItem = styled(NavLink)`
  text-decoration: none;
  color: white;
  // padding: 10px;
  border-radius: 5px;
  font-size: 1rem;
  font-weight:bold;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }

  &.active {
    background-color: rgba(255, 255, 255, 0.9);
    color: #439E6D;
  }

  @media (min-width: 768px) {
    font-size: 0.8rem;
    padding: 5px;
  }
`;

const Dropdown = styled.div`
  position: relative;

  &:hover .dropdown-content {
    display: flex;
  }
`;

const DropdownButton = styled.div`
  color: white;
  padding: 7px;
  font-size: 0.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight:bold;

  &:hover {
    transform: scale(1.05);
  }
`;

const DropdownContent = styled.div`
  display: none;
  flex-direction: column;
  position: absolute;
  top: 28px;
  left: 0;
  background: white;
  min-width: 220px;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  
`;

const DropdownContent2 = styled.div`
  display: flex;
  flex-direction: column;
//   position: absolute;
//   top: 40px;
//   left: 0;
  background: white;
  min-width: 220px;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  margin-bottom:5px;
`;

const DropdownItem = styled(NavLink)`
  text-decoration: none;
  padding: 6px;
  color: #439E6D;
  font-size: 1.1rem;
  transition: 0.3s;

  &:hover {
    background: #439E6D;
    color: white;
  }
`;

const Img = styled.img`
  width: 70px;
  height: auto;
`;

const Sparkles = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  width: 10px;
  height: 10px;
  background-color: yellow;
  border-radius: 50%;
`;

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuRef = useRef();
  const [dropDownOpen, setDropDownOpen]= useState(false);
   const [dropDownOpen2, setDropDownOpen2]= useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const hideHeader = ['/userlogin', '/usersignup', '/forgotpassword'].some(path =>
    location.pathname.includes(path)
  );

  return (
    <HeaderWrap hide={hideHeader}>
      <HeaderUp>
        <HeaderUpLeft>
          <Img src={logo} alt='logo' />
        </HeaderUpLeft>

        <HeaderUpRight>
          <HeaderUpRightItem>
            <FaEnvelope />
            <p>padecglobalservices@gmail.com</p>
          </HeaderUpRightItem>

          <HeaderUpRightItem>
            <FaPhoneAlt />
            <p>+234(0)803 457 9614 , +234(0)904 974 3886</p>
          </HeaderUpRightItem>

          {!mobileMenuOpen && (
            <MobileMenuIcon onClick={() => setMobileMenuOpen(true)}>
              <FaBars />
            </MobileMenuIcon>
          )}

          {mobileMenuOpen && (
            <MobileMenuIcon onClick={() => setMobileMenuOpen(false)}>
              <FaWindowClose />
            </MobileMenuIcon>
          )}
        </HeaderUpRight>
      </HeaderUp>

      {/* DESKTOP MENU */}
      <HeaderDown>
        <MenuItem to='/'>HOME</MenuItem>

        {/* ABOUT US DROPDOWN */}
        <Dropdown>
          <DropdownButton>
            ABOUT<FaChevronDown size={10} />
          </DropdownButton>

          <DropdownContent className='dropdown-content'>

            <DropdownItem to='/aboutus'>
              About us
            </DropdownItem>
            <DropdownItem to='/companyoverview'>
              Company Overview
            </DropdownItem>

            {/* <DropdownItem to='/careers'>
              Careers
            </DropdownItem> */}

            <DropdownItem to='/qhse'>
              QHSE
            </DropdownItem>

              <DropdownItem to='/partners'>
              Our Partners
            </DropdownItem>
          </DropdownContent>
        </Dropdown>

        {/* SERVICES DROPDOWN */}
        <Dropdown>
          <DropdownButton>
            SERVICES <FaChevronDown size={10} />
          </DropdownButton>

          <DropdownContent className='dropdown-content'>

             <DropdownItem to='/services'>
            Services
            </DropdownItem>
        

            <DropdownItem to='/offshoresurvey'>
              Offshore survey
            </DropdownItem>

            <DropdownItem to='/specialsurvey'>
              
              Special survey
            </DropdownItem>

             <DropdownItem to='/onshoresurvey'>
              Onshore survey
            </DropdownItem>

                <DropdownItem to='/engineeringservices'>
              Engineering Services
            </DropdownItem>
          </DropdownContent>
        </Dropdown>

        {/* CLIENT SECTOR DROPDOWN */}
        {/* <Dropdown>
          <DropdownButton>
            CLIENT SECTOR <FaChevronDown size={10} />
          </DropdownButton>

          <DropdownContent className='dropdown-content'>
            <DropdownItem to='/clientsector/oil-gas'>
              Oil & Gas
            </DropdownItem>

            <DropdownItem to='/clientsector/marine'>
              Marine Sector
            </DropdownItem>

            <DropdownItem to='/clientsector/construction'>
              Construction Sector
            </DropdownItem>
          </DropdownContent>
        </Dropdown> */}

        <MenuItem to='/news'>NEWS</MenuItem>
        <MenuItem to='/nigeriancontent'>NIGERIAN CONTENT</MenuItem>
        <MenuItem to='/contactus'>CONTACT US</MenuItem>
      </HeaderDown>

      {/* MOBILE MENU */}
      <MobileMenu ref={menuRef} open={mobileMenuOpen}>
        <MenuItem to='/' onClick={() => setMobileMenuOpen(false)}>
          HOME
        </MenuItem>

        {/* ABOUT US */}
        <Dropdown>
          <DropdownButton onClick={()=>setDropDownOpen(!dropDownOpen)}>
            ABOUT<FaChevronDown size={10} />
          </DropdownButton>

       {dropDownOpen&&<DropdownContent2 className='dropdown-content'>

            <DropdownItem to='/aboutus' onClick={() => setMobileMenuOpen(false)}>
              About us
            </DropdownItem>
            <DropdownItem to='/companyoverview' onClick={() => setMobileMenuOpen(false)}>
              Company Overview
            </DropdownItem>

            <DropdownItem to='/careers' onClick={() => setMobileMenuOpen(false)}>
              Careers
            </DropdownItem>

            <DropdownItem to='/qhse' onClick={() => setMobileMenuOpen(false)}>
              QHSE
            </DropdownItem>

              <DropdownItem to='/partners' onClick={() => setMobileMenuOpen(false)}>
              Our Partners
            </DropdownItem>
          </DropdownContent2>}
        
        </Dropdown>

        {/* SERVICES */}
        <Dropdown>
          <DropdownButton onClick={()=>setDropDownOpen2(!dropDownOpen2)}>
            SERVICES <FaChevronDown size={10} />
          </DropdownButton>

          {dropDownOpen2&&  <DropdownContent2 className='dropdown-content'>

             <DropdownItem to='/services' onClick={() => setMobileMenuOpen(false)}>
            Services
            </DropdownItem>
        

            <DropdownItem to='/offshoresurvey' onClick={() => setMobileMenuOpen(false)}>
              Offshore survey
            </DropdownItem>

            <DropdownItem to='/specialsurvey' onClick={() => setMobileMenuOpen(false)}>
              
              Special survey
            </DropdownItem>

             <DropdownItem to='/onshoresurvey' onClick={() => setMobileMenuOpen(false)}>
              Onshore survey
            </DropdownItem>

                <DropdownItem to='/engineeringservices' onClick={() => setMobileMenuOpen(false)}>
              Engineering Services
            </DropdownItem>
          </DropdownContent2>}

        </Dropdown>

        {/* CLIENT SECTOR */}
        {/* <Dropdown>
          <DropdownButton>
            CLIENT SECTOR <FaChevronDown size={10} />
          </DropdownButton>

          <DropdownContent
            className='dropdown-content'
            style={{ position: 'static', display: 'flex' }}
          >
            <DropdownItem to='/clientsector/oil-gas'>
              Oil & Gas
            </DropdownItem>

            <DropdownItem to='/clientsector/marine'>
              Marine Sector
            </DropdownItem>

            <DropdownItem to='/clientsector/construction'>
              Construction Sector
            </DropdownItem>
          </DropdownContent>
        </Dropdown> */}

        <MenuItem to='/news' onClick={() => setMobileMenuOpen(false)}>
          NEWS
        </MenuItem>

        <MenuItem
          to='/nigeriancontent'
          onClick={() => setMobileMenuOpen(false)}
        >
          NIGERIAN CONTENT
        </MenuItem>

        <MenuItem to='/contactus' onClick={() => setMobileMenuOpen(false)}>
          CONTACT US
        </MenuItem>
      </MobileMenu>
    </HeaderWrap>
  );
};

export default Header;